export default __webpack_public_path__ + "static/media/full_stone.8949909c.png";